const envSettings = window;
export class Config {
  static REACT_APP_API_URL = envSettings.REACT_APP_API_URL;
  static REACT_APP_FLAGSMITH_API = envSettings.REACT_APP_FLAGSMITH_API;
  static REACT_APP_FLAGSMITH_KEY = envSettings.REACT_APP_FLAGSMITH_KEY;
  static REACT_APP_LANDING_PAGE = envSettings.REACT_APP_LANDING_PAGE;
  static REACT_APP_ANALYTICS = envSettings.REACT_APP_ANALYTICS;
  static REACT_APP_GUACAMOLE_API = envSettings.REACT_APP_GUACAMOLE_API;
}
